import React from 'react'
import { SelectInputProps } from 'react-admin'
import { getTimeLabels } from 'services/utils/date'
import KSelectInput from './KSelectInput'

const TimePicker: React.FC<SelectInputProps> = (props) => {
  return (
    <KSelectInput {...props} choices={getTimeLabels()} resettable fullWidth />
  )
}

export default TimePicker
